import React from "react";
import AsyncAutoCompleteContained from "../../AsyncAutoCompleteContained";
import { AutoCompleteProps } from "../../../Types/AutoComplete/AutoCompleteProps"
import { useTranslation } from "react-i18next";

const SupplierAutoComplete: React.FC<AutoCompleteProps> = ({ onChange, valueId, label, load = true, infoText, disabled = false,
    error, helperText, inputValueOverride }) => {
    const { t } = useTranslation();
    return (
        <AsyncAutoCompleteContained
            label={label ?? t("common.supplier")}
            url="/autocompleteApi/Supplier"
            valueId={valueId}
            load={load}
            onChange={onChange}
            infoText={infoText}
            error={error}
            helperText={helperText}
            disabled={disabled}
            inputValueOverride={inputValueOverride}
        />
    );
};

export default SupplierAutoComplete;
